<div class="hw">

  <!-- Header -->
  <header class="hw__header">
    <div>
      <h1 class="hw__title">
        <span class="hw__title-icon"><i class="fa-solid fa-clipboard-list"></i></span>
        {{ 'HOMEWORK.TITLE' | translate }}
      </h1>
      <p class="hw__subtitle">{{ 'HOMEWORK.SUBTITLE' | translate }}</p>
    </div>
    <span class="hw__badge">
      {{ 'HOMEWORK.COUNT' | translate:{ count: filtered().length } }}
    </span>
  </header>

  <!-- Tabs -->
  <nav class="hw__tabs">
    <button class="hw__tab" [class.is-active]="activeTab() === 'all'" (click)="setTab('all')" type="button">
      {{ 'HOMEWORK.TABS.ALL' | translate }}
      <span class="hw__tab-pill">{{ counts().all }}</span>
    </button>
    <button class="hw__tab" [class.is-active]="activeTab() === 'exam'" (click)="setTab('exam')" type="button">
      <i class="fa-solid fa-file-pen"></i>
      {{ 'HOMEWORK.TABS.EXAM' | translate }}
      <span class="hw__tab-pill">{{ counts().exam }}</span>
    </button>
    <button class="hw__tab" [class.is-active]="activeTab() === 'practice'" (click)="setTab('practice')" type="button">
      <i class="fa-solid fa-dumbbell"></i>
      {{ 'HOMEWORK.TABS.PRACTICE' | translate }}
      <span class="hw__tab-pill">{{ counts().practice }}</span>
    </button>
    <button class="hw__tab" [class.is-active]="activeTab() === 'evaluation'" (click)="setTab('evaluation')" type="button">
      <i class="fa-solid fa-chart-simple"></i>
      {{ 'HOMEWORK.TABS.EVALUATION' | translate }}
      <span class="hw__tab-pill">{{ counts().evaluation }}</span>
    </button>
  </nav>

  <!-- Search -->
  <div class="hw__search">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input type="search"
           [value]="query()"
           (input)="onQuery($any($event.target).value)"
           [placeholder]="'HOMEWORK.SEARCH_PLACEHOLDER' | translate">
  </div>

  <!-- Skeleton -->
  <div *ngIf="loading()" class="hw__skeleton">
    <div class="hw__skel-card" *ngFor="let _ of [1,2,3]"></div>
  </div>

  <ng-container *ngIf="!loading()">

    <!-- Erreur de chargement : jamais de données de substitution -->
    <app-error-state *ngIf="errored()"
                     titleKey="HOMEWORK.ERROR_TITLE"
                     messageKey="HOMEWORK.ERROR_DESC"
                     (retry)="reload()"></app-error-state>

    <ng-container *ngIf="!errored()">

    <!-- Grid -->
    <div class="hw__grid" *ngIf="filtered().length > 0; else emptyTpl">
      <article *ngFor="let a of filtered()" class="hw__card"
               [class.hw__card--urgent]="isDueSoon(a)"
               [class.hw__card--overdue]="isOverdue(a)">

        <!-- Top strip: mode badge + urgency chip -->
        <div class="hw__card-top">
          <span class="hw__mode-badge">
            <i [class]="modeIcon(a.testMode)"></i>
            {{ 'HOMEWORK.MODE.' + (a.testMode?.toUpperCase() ?? 'OTHER') | translate }}
          </span>
          <span class="hw__urgency" *ngIf="isDueSoon(a)">
            <i class="fa-solid fa-triangle-exclamation"></i>
            {{ 'HOMEWORK.DUE_SOON' | translate }}
          </span>
          <span class="hw__urgency hw__urgency--overdue" *ngIf="isOverdue(a)">
            <i class="fa-solid fa-circle-exclamation"></i>
            {{ 'HOMEWORK.OVERDUE' | translate }}
          </span>
        </div>

        <!-- Title -->
        <h2 class="hw__card-title">{{ a.testTitle }}</h2>

        <!-- Meta row -->
        <ul class="hw__meta">
          <li *ngIf="a.subjectName">
            <i class="fa-solid fa-book"></i>
            {{ a.subjectName }}
          </li>
          <li>
            <i [class]="targetIcon(a)"></i>
            {{ targetLabel(a) }}
          </li>
          <li *ngIf="a.professorFullName">
            <i class="fa-solid fa-chalkboard-teacher"></i>
            {{ a.professorFullName }}
          </li>
          <li *ngIf="a.dueDate" [class.hw__meta-urgent]="isDueSoon(a) || isOverdue(a)">
            <i class="fa-solid fa-calendar-day"></i>
            {{ a.dueDate | localizedDate: 'dd MMM yyyy, HH:mm' }}
          </li>
        </ul>

        <!-- Instructions -->
        <p class="hw__instr" *ngIf="a.instructions">{{ a.instructions }}</p>

        <!-- CTA -->
        <button class="hw__start-btn" type="button" (click)="startTest(a)">
          <i class="fa-solid fa-play"></i>
          {{ 'HOMEWORK.START_BTN' | translate }}
        </button>

      </article>
    </div>

    <ng-template #emptyTpl>
      <div class="hw__empty">
        <div class="hw__empty-icon"><i class="fa-solid fa-party-horn"></i></div>
        <h3>{{ 'HOMEWORK.EMPTY_TITLE' | translate }}</h3>
        <p>{{ 'HOMEWORK.EMPTY_DESC' | translate }}</p>
      </div>
    </ng-template>

    </ng-container>

  </ng-container>

</div>
